import { Loader2 } from 'lucide-react';
import { type CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface LoaderProps {
  text?: string;
  className?: string;
  /** Escape hatch for the editor, which overlays this on the document canvas. */
  style?: CSSProperties;
}

/**
 * Full-height "we are working on it" state, used as the router's Suspense fallback and while
 * the editor parses a document.
 *
 * The height used to be `calc(100vh - 80.8px)`, a subtraction of the old header's height that
 * nothing kept in step with the header. `min-h-[60vh]` centres it in whatever space the shell
 * actually gives it instead.
 */
function Loader({ text, className, style }: LoaderProps) {
  const { t } = useTranslation('web', { keyPrefix: 'components.loader' });

  return (
    <div
      role="status"
      className={cn('flex min-h-[60vh] w-full items-center justify-center gap-3 bg-background', className)}
      style={style}
    >
      <Loader2 className="animate-spin text-primary" />
      <p className="text-h4">{text ?? t('text')}</p>
    </div>
  );
}

export default Loader;
